import {
  _ACTIONS,
  _HTTP,
  _MEMBER,
  _MESSAGES,
  _RESULT,
} from "../utils/constants";
import { createToast } from "../utils/toast";
import _ from "lodash";

//const requestHelper = new RequestHelper();

/**
 * Fetches generic data from a specified route and performs actions on the response.
 *
 * @param {RequestHelper} requestHelper - The request helper object.
 * @param {Object} params - The parameters to be sent with the request.
 * @param {Function} actions - The function to be executed with the response data.
 * @param {string} route - The API endpoint to send the request to.
 * @param {string} [errorMessage=_MESSAGES.error] - The error message to display if the request fails.
 * @deprecated Use 'services/DataService' instead
 */
export const getDataGeneric = (
  requestHelper,
  params,
  actions,
  route,
  errorMessage = _MESSAGES.error,
) => {
  requestHelper
    .doRequest(_ACTIONS.GET, `${route}`, params)
    .then((res) => {
      if (_HTTP.ok !== res.status) {
        throw new Error(errorMessage);
      }
      _.isUndefined(res.data[_MEMBER])
        ? actions(res.data)
        : actions(res.data[_MEMBER]);
    })
    .catch((error) => {
      createToast(_RESULT.error, error.message);
    });
};
